import React, { useState, useEffect, useRef } from "react";
import Menubar from "../Menubar/Menubar";
import { Outlet } from "react-router-dom";
import "../Dashboard/Dashboard.css";
import { Tooltip } from "antd";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import Loader from "../Loader/Loader";
import useMinimumLoading from "../hooks/Useminimumloading";
// import { FiUploadCloud } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import axios from "axios";
import { API_URL } from "../../Config";

const Discounts = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });

  const [couponForm, setCouponForm] = useState({
    couponName: "",
    discount: "",
    expiryDate: "",
  });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [coupons, setCoupons] = useState([]);
  const [loadingCoupons, setLoadingCoupons] = useState(false);
  const showLoader = useMinimumLoading(loadingCoupons);
  useEffect(() => {
    fetchCoupons();
  }, []);

  const fetchCoupons = async () => {
    try {
      setLoadingCoupons(true);

      const res = await axios.get(`${API_URL}/coupons`);

      if (res.data.success) {
        setCoupons(res.data.data);
      }
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoadingCoupons(false);
    }
  };
  const rowsPerPage_discount = 20;
  const [currentPage_discount, setCurrentPage_discount] = useState(1);

  const indexOfLastTable_discount = currentPage_discount * rowsPerPage_discount;
  const indexOfFirstTable_discount =
    indexOfLastTable_discount - rowsPerPage_discount;

  const current_discount = coupons.slice(
    indexOfFirstTable_discount,
    indexOfLastTable_discount,
  );

  const totalPages_discount = Math.ceil(coupons.length / rowsPerPage_discount);
  const handlePageChange_discount = (pageNumber_discount) => {
    setCurrentPage_discount(pageNumber_discount);
  };

  const handleNextPage_discount = () => {
    if (currentPage_discount < totalPages_discount) {
      setCurrentPage_discount(currentPage_discount + 1);
    }
  };

  const handlePrevPage_discount = () => {
    if (currentPage_discount > 1) {
      setCurrentPage_discount(currentPage_discount - 1);
    }
  };

  const generatePageNumbers_discount = () => {
    const pageNumbers_discount = [];

    if (totalPages_discount <= 3) {
      for (let i = 1; i <= totalPages_discount; i++) {
        pageNumbers_discount.push(i);
      }
    } else {
      if (currentPage_discount > 2) {
        pageNumbers_discount.push(1);
        pageNumbers_discount.push("...");
      }
      for (
        let i = currentPage_discount - 1;
        i <= currentPage_discount + 1;
        i++
      ) {
        if (i > 0 && i <= totalPages_discount) {
          pageNumbers_discount.push(i);
        }
      }
      if (currentPage_discount < totalPages_discount - 1) {
        pageNumbers_discount.push("...");
        pageNumbers_discount.push(totalPages_discount);
      }
    }
    return pageNumbers_discount;
  };

  const [selectedRows_discount, setSelectedRows_discount] = useState([]);

  const handleRowCheckboxChange_discount = (order) => {
    setSelectedRows_discount((prevSelected) =>
      prevSelected.includes(order)
        ? prevSelected.filter((id) => id !== order)
        : [...prevSelected, order],
    );
  };

  const handleSelectAll_discount = () => {
    if (selectedRows_discount.length === current_discount.length) {
      setSelectedRows_discount([]);
    } else {
      setSelectedRows_discount(current_discount.map((c) => c.id));
    }
  };
  const [isOpen_popupForm, setIsOpen_popupForm] = useState(false);

  // const fileInputRef = useRef(null);

  // const handleBoxClick = () => {
  //   fileInputRef.current.click();
  // };

  const [showPopup_filter, setShowPopup_filter] = useState(false);
  const filterRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowPopup_filter(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const handleChange = (e) => {
    setCouponForm({
      ...couponForm,
      [e.target.name]: e.target.value,
    });
  };
  const handleSaveCoupon = async () => {
    const { couponName, discount, expiryDate } = couponForm;

    if (!couponName || !discount || !expiryDate) {
      alert("Fill all fields");
      return;
    }

    try {
      setIsSaving(true); // 🔥 start loader

      const res = await axios.post(`${API_URL}/create`, {
        couponName,
        discount,
        expiryDate,
      });

      if (res.data.success) {
        alert("Coupon Saved ✅");
        await fetchCoupons();
        setCouponForm({
          couponName: "",
          discount: "",
          expiryDate: "",
        });

        setIsOpen_popupForm(false);
      }
    } catch (err) {
      console.error(err);
      alert("Error saving coupon ❌");
    } finally {
      setIsSaving(false); // 🔥 stop loader
    }
  };

  const handleDeleteCoupon = async (id) => {
    const confirmDelete = window.confirm("Delete this coupon?");
    if (!confirmDelete) return;

    try {
      await axios.delete(`${API_URL}/coupon/${id}`);

      // Option 1 (Best UX): Update state instantly
      setCoupons((prev) => prev.filter((c) => c.id !== id));

      // Option 2 (If you want fresh data from DB)
      // fetchCoupons();
    } catch (err) {
      console.error("Delete error:", err);
      alert("Error deleting coupon");
    }
  };

  return (
    <div className="flex bg-[#F8F9FA]">
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              Discounts
            </p>
          </div>

          <div className="flex items-center gap-1">
            <div className="flex items-center">
              <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
                <div className="flex items-center justify-center fill-[#1D2826]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Isolation_Mode"
                    data-name="Isolation Mode"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                  >
                    <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z"></path>
                  </svg>
                </div>
                <input
                  type="text"
                  className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
                />
              </div>

              <div className="">
                <button className="Btn">
                  <svg
                    className="svgIcon"
                    viewBox="0 0 384 512"
                    height="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path>
                  </svg>
                  <span className="icon2"></span>
                  <span className="tooltip text-sm">Download</span>
                </button>
              </div>

              <div className="flex items-center">
                <div className="relative inline-block" ref={filterRef}>
                  <div
                    onClick={() => setShowPopup_filter((prev) => !prev)}
                    className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${
                      showPopup_filter
                        ? "border-[#1D2826]"
                        : "border-transparent hover:border-[#1D2826]"
                    }`}
                  >
                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "100%" : "0%",
                          transform: `translate(${
                            showPopup_filter ? "-100%" : "0"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>

                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full -my-2.5">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "0%" : "100%",
                          transform: `translate(${
                            showPopup_filter ? "0" : "-100%"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>

                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "100%" : "0%",
                          transform: `translate(${
                            showPopup_filter ? "-100%" : "0"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>
                  </div>

                  {showPopup_filter && (
                    <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4">
                      <div className="flex justify-between gap-2">
                        {["Today", "Week", "Month", "Year"].map((label) => (
                          <button
                            key={label}
                            className="flex-1 py-1 px-2 bg-gray-100 active:bg-[#DAE0CE] hover:bg-[#DAE0CE] rounded text-sm font-medium"
                          >
                            {label}
                          </button>
                        ))}
                      </div>

                      <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                          <input
                            type="date"
                            className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                          />
                          <span className="text-sm text-gray-500">-</span>
                          <input
                            type="date"
                            className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Button */}
        <div className="flex justify-between gap-10 mt-8">
          <button
            onClick={() => setIsOpen_popupForm(true)}
            className="px-6 z-30 py-2 bg-[#1D2826] rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-900 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
          >
            + Add Discount
          </button>

          <div className="relative z-50">
            {isOpen_popupForm && (
              <div
                onClick={() => setIsOpen_popupForm(false)}
                className="fixed inset-0 bg-black bg-opacity-30 z-40 backdrop_popupForm"
              />
            )}

            <div
              className={`fixed top-0 right-0 h-full w-[85%] md:w-[640px] bg-white z-50 shadow-lg transform transition-transform duration-500 ease-in-out ${
                isOpen_popupForm ? "translate-x-0" : "translate-x-full"
              } panel_popupForm`}
            >
              <div className="p-4 flex justify-between items-center border-b header_popupForm">
                <h2 className="text-[#1D2826] text-lg font-semibold">
                  Add Discount
                </h2>
                <button
                  onClick={() => setIsOpen_popupForm(false)}
                  className="text-gray-500 hover:text-black text-xl"
                >
                  <MdCancel />
                </button>
              </div>

              <div className="p-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-3 items-center max-h-[85vh] overflow-y-auto py-2">
                  <div className="flex flex-col w-full">
                    <label
                      htmlFor="couponName"
                      className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                    >
                      Coupon Name
                    </label>
                    <input
                      name="couponName"
                      value={couponForm.couponName}
                      onChange={handleChange}
                      placeholder="Enter Coupon Name"
                      className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none"
                    />
                  </div>

                  <div className="flex flex-col w-full">
                    <label
                      htmlFor="discount"
                      className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                    >
                      Discount Percentage
                    </label>
                    <input
                      type="number"
                      name="discount"
                      value={couponForm.discount}
                      onChange={handleChange}
                      placeholder="Enter Discount Percentage"
                      className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none"
                    />
                  </div>

                  <div className="flex flex-col w-full">
                    <label
                      htmlFor="expiryDate"
                      className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
                    >
                      Expiry Date
                    </label>
                    <input
                      type="date"
                      name="expiryDate"
                      value={couponForm.expiryDate}
                      onChange={handleChange}
                      className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none"
                    />
                  </div>

                  <br />

                  <div className="grid grid-cols-2 gap-3 mt-3">
                    <button
                      onClick={() => setIsOpen_popupForm(false)}
                      disabled={isSaving}
                      className="px-6 py-2 bg-gray-800 rounded-lg text-white text-sm disabled:opacity-50"
                    >
                      Cancel
                    </button>

                    <button
                      onClick={handleSaveCoupon}
                      disabled={isSaving}
                      className={`px-6 py-2 rounded-lg text-white text-sm transition-all duration-300 flex items-center justify-center gap-2
    ${isSaving ? "bg-green-500 cursor-not-allowed" : "bg-green-900 hover:scale-95"}
  `}
                    >
                      {isSaving ? (
                        <>
                          {/* Spinner */}
                          <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                          Saving...
                        </>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div>
          <div className="shadow-md rounded-lg mt-5">
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                  <tr>
                    <th className="p-4">
                      <input
                        type="checkbox"
                        onChange={handleSelectAll_discount}
                        checked={
                          selectedRows_discount.length ===
                            current_discount.length &&
                          current_discount.length > 0
                        }
                      />
                    </th>
                    <th className="p-4 w-1/10">Name</th>
                    <th className="p-4 w-1/10">Discount</th>
                    <th className="p-4 w-1/10"> Expiry Date</th>
                    <th className="p-4 w-1/12">Status</th>
                    {/* <th className="p-4 w-1/10">Payment</th> */}
                    <th className="p-4 w-1/10 text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showLoader ? (
                    <tr>
                      <td colSpan="10" className="text-center py-5">
                        <Loader
                          label="Loading..."
                          fullScreen={false}
                          className="py-2"
                        />
                      </td>
                    </tr>
                  ) : current_discount.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center py-5">
                        No coupons found
                      </td>
                    </tr>
                  ) : (
                    current_discount.map((coupon, index) => {
                      const isExpired =
                        new Date(coupon.expiry_date) < new Date();

                      return (
                        <tr
                          key={coupon.id}
                          className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                        >
                          {/* Checkbox */}
                          <td className="px-4 py-3">
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleRowCheckboxChange_discount(coupon.id)
                              }
                              checked={selectedRows_discount.includes(
                                coupon.id,
                              )}
                            />
                          </td>

                          {/* Name */}
                          <td className="px-4 py-3">
                            <Tooltip title={coupon.coupon_name}>
                              {coupon.coupon_name}
                            </Tooltip>
                          </td>

                          {/* Discount */}
                          <td className="px-4 py-3">{coupon.discount}%</td>

                          {/* Expiry Date */}
                          <td className="px-4 py-3">
                            {new Date(coupon.expiry_date).toLocaleDateString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              },
                            )}
                          </td>

                          {/* Status */}
                          <td className="pr-4 py-3">
                            <button
                              className={`w-20 px-1 py-1 rounded-lg text-xs ${
                                isExpired
                                  ? "bg-red-100 text-red-500"
                                  : "bg-green-100 text-green-600"
                              }`}
                            >
                              {isExpired ? "Expired" : "Active"}
                            </button>
                          </td>

                          {/* Created At */}
                          {/* <td className="px-4 py-3">{coupon.created_at}</td> */}

                          {/* Actions */}
                          <td>
                            <div className="flex justify-center">
                              {/* <button className="px-2 py-1 text-gray-400 hover:text-black hover:scale-125">
                                <FaEye size={15} />
                              </button> */}

                              <button className="px-2 py-1 text-gray-400 hover:text-black hover:scale-125">
                                <FaEdit size={14} />
                              </button>

                              <button
                                onClick={() => handleDeleteCoupon(coupon.id)}
                                className="px-2 py-1 text-gray-400 hover:text-red-500 hover:scale-125"
                              >
                                <MdDelete size={15} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            <nav
              className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
              aria-label="Table navigation"
            >
              <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                Showing{" "}
                <span className="font-semibold text-gray-700 dark:text-white">
                  {indexOfFirstTable_discount + 1}-
                  {Math.min(indexOfLastTable_discount, coupons.length)}
                  {coupons.length}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-700 dark:text-white">
                  {coupons.length}
                </span>
              </span>

              <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                <li>
                  <button
                    onClick={handlePrevPage_discount}
                    disabled={currentPage_discount === 1}
                    className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <MdKeyboardDoubleArrowLeft />
                  </button>
                </li>
                {generatePageNumbers_discount().map((page, index) =>
                  page === "..." ? (
                    <li
                      key={index}
                      className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <span>...</span>
                    </li>
                  ) : (
                    <li key={index}>
                      <button
                        onClick={() => handlePageChange_discount(page)}
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
                          currentPage_discount === page
                            ? "text-green-500 underline underline-offset-2"
                            : ""
                        }`}
                      >
                        {page}
                      </button>
                    </li>
                  ),
                )}
                <li>
                  <button
                    onClick={handleNextPage_discount}
                    disabled={currentPage_discount === totalPages_discount}
                    className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                  >
                    <MdKeyboardDoubleArrowRight />
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Discounts;
